<template>
  <grouped-bar-chart style="position: relative; height:220px" :data="this.groupedBarChartData"
                     :options="this.groupedBarChartOptions"
                     v-if="this.groupedBarChartData"></grouped-bar-chart>
</template>

<script>
  import moment from "moment";
  import {scrapedProfileSections} from "../../../constants/constants";
  import GroupedBarChart from "../Wrappers/groupedBarChart";

  import {getNumberOfChangesInSection} from "../../../helpers/helpers";

  export default {
    name: "sectionsChangesBars",
    components: {GroupedBarChart},
    props: ['profile'],
    data(){
      return {
        groupedBarChartData: {},
        groupedBarChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top"
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true,
                color: '#eee'
              },
            }],
            yAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                suggestedMin: 0,
              }
            }]
          },
        },
      }
    },
    methods: {
      getNumberOfChangesInSection(item) {
        return getNumberOfChangesInSection(item);
      },
      composeGroupedBarChartData() {
        const labels = this.profile.history.map(e => e.scrapedDate).reverse().map(e => moment(e).format('DD-MMM')).slice(1);
        let datasets = [];
        let sections = [];
        for (let n in this.profile.scrapedProfile) {
          if (n !== 'meta' && n !== 'scrapedDate' &&
            n !== 'otherPeopleSameName' && n !== 'profileLanguages' && n !== 'proposedCourses' &&
            n !== 'peopleAlsoViewed' && n !== 'similarProfiles'
            && this.profile.scrapedProfile[n] !== false) {
            sections.push(n);
          }
        }
        let profileChanges = this.profile.edges.market.profileChanges.reverse();
        for (let i = 0; i < sections.length; i++) {
          let section = sections[i];
          let bar = {
            label: section,
            backgroundColor: scrapedProfileSections.filter(e => e.section === section)[0].colorFill,
            borderColor: scrapedProfileSections.filter(e => e.section === section)[0].colorLine,
            borderWidth: 1,
            data: profileChanges.map(e => this.getNumberOfChangesInSection(e[section]))
          };
          datasets.push(bar);
        }
        datasets.push({
            label: 'Average',
            type: 'line',
            pointRadius: 0.1,
            lineTension: 0,
            backgroundColor: '#aaa',
            fill: false,
            data: [...Array(labels.length)].fill(this.profile.edges.market.avgProfileChanges)
          },
          {
            type: 'line',
            label: 'Amount of Changes',
            pointRadius: 0.1,
            lineTension: 0.4,
            fill: false,
            backgroundColor: '#833030',
            borderColor: '#933939',
            data: this.profile.edges.market.profileChangesCounters
          });

        return {labels, datasets};
      },
    },
    mounted(){
      this.groupedBarChartData = this.composeGroupedBarChartData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/sectionsChangesBars.vue